// import React, { useEffect, useRef } from "react";
// import { Icon } from "@iconify/react";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

// export default function App() {
//     const sectionRef = useRef(null);

//     useEffect(() => {
//         const ctx = gsap.context(() => {
//             const cards = gsap.utils.toArray(".step-card");
//             const circles = gsap.utils.toArray(".step-circle");

//             gsap.from(cards, {
//                 scrollTrigger: {
//                     trigger: sectionRef.current,
//                     start: "top 80%",
//                 },
//                 y: 50,
//                 opacity: 0,
//                 duration: 0.8,
//                 stagger: 0.2,
//                 ease: "power3.out",
//             });

//             gsap.from(circles, {
//                 scrollTrigger: {
//                     trigger: sectionRef.current,
//                     start: "top 80%",
//                 },
//                 scale: 0,
//                 rotation: 180,
//                 duration: 1,
//                 ease: "elastic.out(1,0.5)",
//                 stagger: 0.2,
//             });
//         }, sectionRef);

//         return () => ctx.revert();
//     }, []);

//     const steps = [
//         {
//             id: "01",
//             mainTitle: 'Design',
//             title: "Deep Discovery & Planning",
//             desc: "Every great solution starts understanding. We take the time to learn about your business, challenges, and goals.",
//             icon: "mdi:magnify",
//         },
//         {
//             id: "02",
//             mainTitle: 'Development',

//             title: "Development & Implement",
//             desc: "Every great solution starts understanding. We take the time to learn about your business, challenges, and goals.",
//             icon: "mdi:code-tags",
//         },
//         {
//             id: "03",
//             mainTitle: 'Deploy',

//             title: "Optimization & Support",
//             desc: "Every great solution starts understanding. We take the time to learn about your business, challenges, and goals.",
//             icon: "mdi:chart-line",
//         },
//     ];

//     return (
//         <div className="bg-black text-white min-h-screen flex flex-col items-center justify-center px-6 py-20">
//             <section ref={sectionRef} className="w-full text-center ">
//                 <div className=" mb-28 max-w-screen-lg mx-auto ">
//                     <button className="bg-white/10 border border-white/20 px-5 py-2 rounded-full text-sm mb-6 hover:bg-white/20 transition-all">
//                         PROBLEMS THAT AIM TO SOLVE
//                     </button>

//                     <h1
//                         className="text-5xl md:text-7xl font-light leading-snug text-gray-400"
//                     >
//                         What we create{" "}
//                         <span className="text-white font-normal">for our</span>{" "}
//                         digital marketing customer
//                     </h1>
//                 </div>

//                 <div className="flex flex-col lg:flex-row items-center justify-center gap-12 relative ">
//                     {steps.map((s, i) => (
//                         <div key={s.id} className="relative step-card bg-neutral-900 rounded-2xl p-12 text-left w-full max-w-screen-xl  shadow-xl group " >
//                             <div className="step-circle group-hover:rotate-210  bg-gradient-to-br from-orange-400 to-orange-600 -rotate-90 absolute -top-8 left-1/2 -translate-x-1/2 bg-orange-400 text-white w-20 h-20 rounded-2xl flex items-center justify-center font-semibold text-3xl shadow-lg">

//                                 {s.id}
//                             </div>

//                             <div className="flex items-center gap-3 my-4 justify-center">
//                                 <h3 className="font-semibold text-lg md:text-5xl text-center">{s.mainTitle}</h3>
//                             </div>

//                             <div
//                                 class="mt-6 w-full h-0.5 bg-gradient-to-r text-center from-transparent via-white to-transparent rounded-full transform group-hover:w-1/2 items-center group-hover:h-1 transition-all duration-500 animate-pulse"
//                             ></div>
//                             <div className="flex items-center gap-3 mt-10 mb-4 justify-center">
//                                 <h3 className="font-semibold text-lg md:text-2xl text-center">{s.title}</h3>
//                             </div>

//                             <p className="text-gray-400 text-sm md:text-lg text-center">{s.desc}</p>
//                              <div className="flex justify-center mt-6">
//                                  <Icon
//                                      icon={s.icon}
//                                      className="text-4xl text-orange-400 group-hover:scale-125 group-hover:rotate-12 transition-transform duration-500"
//                                  />
//                              </div>

//                             {i < steps.length - 1 && (
//                                 <>
//                                     <div className="hidden lg:block absolute top-1/2 right-[-60px] w-[120px] h-[2px] bg-gradient-to-r from-orange-500/0 via-orange-500/50 to-orange-500/0"></div>
//                                     <div className="lg:hidden absolute bottom-[-50px] left-1/2 -translate-x-1/2 w-[2px] h-[80px] bg-gradient-to-b from-orange-500/0 via-orange-500/50 to-orange-500/0"></div>
//                                 </>
//                             )}
//                         </div>
//                     ))}
//                 </div>

//             </section>
//         </div>
//     );
// }



import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function WorkProcessSection() {
    const sectionRef = useRef(null);
    const titleRef = useRef(null);

    useEffect(() => {
        const ctx = gsap.context(() => {
            const cards = gsap.utils.toArray(".step-card");
            const circles = gsap.utils.toArray(".step-circle");
            const icons = gsap.utils.toArray(".step-card .icon-fade"); // optional target inside card

            // Cards: rise up and fade in when section enters view
            gsap.from(cards, {
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%",
                    // once: true, // uncomment if you want the animation to run only once
                },
                y: 40,
                opacity: 0,
                duration: 0.8,
                stagger: 0.18,
                ease: "power3.out",
            });

            gsap.from(titleRef.current, {
                opacity: 0,
                x: 80,
                duration: 1.2,
                ease: "power3.out",
            });

            // Circles: pop/rotate in with elastic feel
            gsap.from(circles, {
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%",
                },
                scale: 0,
                rotation: 180,
                duration: 0.9,
                ease: "elastic.out(1, 0.6)",
                stagger: 0.18,
            });

            // Icons (if present): subtle pop
            if (icons.length) {
                gsap.from(icons, {
                    scrollTrigger: {
                        trigger: sectionRef.current,
                        start: "top 78%",
                    },
                    x: 12,
                    opacity: 0,
                    duration: 0.6,
                    stagger: 0.18,
                    ease: "power2.out",
                });
            }

            // Optional --- add a small subtle parallax on scroll for the whole section
            // gsap.to(sectionRef.current, {
            //   scrollTrigger: {
            //     trigger: sectionRef.current,
            //     start: "top bottom",
            //     end: "bottom top",
            //     scrub: 0.5,
            //   },
            //   y: -20,
            // });
        }, sectionRef);

        return () => ctx.revert();
    }, []);

    const steps = [
        {
            id: "01",
            mainTitle: 'Design',
            title: "Deep Discovery & Planning",
            desc: "Every great solution starts understanding. We take the time to learn about your business, challenges, and goals.",
            icon: "mdi:magnify",
        },
        {
            id: "02",
            mainTitle: 'Development',

            title: "Development & Implement",
            desc: "Every great solution starts understanding. We take the time to learn about your business, challenges, and goals.",
            icon: "mdi:code-tags",
        },
        {
            id: "03",
            mainTitle: 'Deploy',

            title: "Optimization & Support",
            desc: "Every great solution starts understanding. We take the time to learn about your business, challenges, and goals.",
            icon: "mdi:chart-line",
        },
    ];

    return (
        <div className="bg-black text-white min-h-screen flex flex-col items-center justify-center  ">
            <section ref={sectionRef} className="w-full text-center border-2 border-orange-950 rounded-3xl px-4 md:px-10 lg:px-20 py-20 ">
                <div className=" mb-28 max-w-screen-lg mx-auto ">


                    <div className="justify-center flex ">
                        <button className="bg-white/10 border border-white/20 px-5 py-2 rounded-full text-sm mb-6 hover:bg-white/20 transition-all flex">
                            <Icon
                                icon="material-symbols:lightbulb-2-rounded"
                                className="mr-1.5 text-[#F26A33] drop-shadow-[0_0_6px_#F26A33]"
                                width="22"
                                height="20"
                            />

                          WORKIGN PROCCESS
                        </button>
                    </div>

                    <h1 ref={titleRef}
                        className="text-5xl md:text-7xl font-light leading-snug text-gray-400"
                    >
                        What we create{" "}
                        <span className="text-white font-normal">for our</span>{" "}
                        digital marketing customer
                    </h1>
                </div>

                <div className="flex flex-col lg:flex-row itemscenter justify-center gap-12 relative ">
                    {steps.map((s, i) => (
                        <div key={s.id} className="relative step-card bg-neutral-900 rounded-2xl p-12 text-left w-full max-w-screen-xl  shadow-xl group " >
                            <div className="step-circle group-hover:rotate-210  bg-gradient-to-br from-orange-400 to-orange-600 -rotate-90 absolute -top-8 left-1/2 -translate-x-1/2 bg-orange-400 text-white w-20 h-20 rounded-2xl flex items-center justify-center font-semibold text-3xl shadow-lg">

                                {s.id}
                            </div>

                            <div className="flex items-center gap-3 my-4 justify-center">
                                <h3 className="font-semibold text-lg md:text-5xl text-center">{s.mainTitle}</h3>
                            </div>

                            <div
                                className="mt-6 w-full h-0.5 bg-gradient-to-r text-center from-transparent via-white to-transparent rounded-full transform group-hover:w-1/2 items-center group-hover:h-1 transition-all duration-500 animate-pulse"
                            ></div>
                            <div className="flex items-center gap-3 mt-10 mb-4 justify-center">
                                <h3 className="font-semibold text-lg md:text-2xl text-center">{s.title}</h3>
                            </div>

                            <p className="text-gray-400 text-sm md:text-lg text-center">{s.desc}</p>
                            <div className="flex justify-center mt-6">
                                <Icon
                                    icon={s.icon}
                                    className="icon-fade text-4xl text-orange-400 group-hover:scale-125 group-hover:rotate-12 transition-transform duration-500"
                                />
                            </div>

                            {i < steps.length - 1 && (
                                <>
                                    <div className="hidden lg:block absolute top-1/2 right-[-60px] w-[120px] h-[2px] bg-gradient-to-r from-orange-500/0 via-orange-500/50 to-orange-500/0"></div>
                                    <div className="lg:hidden absolute bottom-[-50px] left-1/2 -translate-x-1/2 w-[2px] h-[80px] bg-gradient-to-b from-orange-500/0 via-orange-500/50 to-orange-500/0"></div>
                                </>
                            )}
                        </div>
                    ))}
                </div>

            </section>
        </div>
    );
}
